import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import Loading from '../Loading/Loading';
import styles from './SidebarLoading.module.scss';

const SidebarLoading = () => {
  return (
    <ShimmerContainer className={styles.container}>
      <div className={styles.header} />
      <div className={styles.subtitle} />
      <Loading />
    </ShimmerContainer>
  );
};

export default SidebarLoading;
